/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = document.querySelector('.section-main-product');
        this.mainProductForm = this.section.querySelector('.js-product');
        this.buyButtons = this.section.querySelector('buy-buttons');
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantContainer = this.querySelector('.sticky-atc__details__variant');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
        this.optionSelectionContainer = this.querySelector('.sticky-atc__option-selection');
        this.mobileOptionSelector = this.querySelector('.sticky-atc__option-selector .btn');
        this.priceContainer = this.querySelector('.sticky-atc__details__price');
        this.optionValue = this.querySelector('.sticky-atc__opt-value');

        // A/B IHR-PDP-6: Convert adds this class for the variant arm. For previews, ?ab_sticky=full
        // turns it on for the rest of the browser tab and ?ab_sticky=off turns it back off.
        try {
          const abSticky = new URLSearchParams(window.location.search).get('ab_sticky');
          if (abSticky) sessionStorage.setItem('ab_sticky', abSticky);
          if (sessionStorage.getItem('ab_sticky') === 'full') {
            document.documentElement.classList.add('ab-sticky-full');
          }
        } catch (e) {}

        this.throttledOnScroll = throttle(StickyAtc.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        // Always bind: the button is mobile-only via CSS, and a page that loads wide then narrows
        // (rotation, resized window, dev-tools phone view) otherwise gets a dead Size button.
        if(this.mobileOptionSelector != null){
          this.mobileOptionSelector.addEventListener('click', this.onOptionSelectorClick.bind(this));
        }
        // if(window.innerWidth < 767){
        //   if(getCookie("remove_sticky_ATC") == "true"){
        //     this.closest('.custom-sticky-bar').classList.add('hidden');
        //   }
        // }

        this.section.addEventListener('on:variant:change', this.onVariantChange.bind(this));
        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
        this.updatePrice();
        this.optionClone = null;

        if(this.section.querySelectorAll('.main-option-container .option-selector').length > 0){
          this.section.querySelectorAll('.main-option-container .option-selector').forEach((option) => {
            if(option.dataset.option != 'Color' && this.optionClone == null){
              this.optionClone = option;
              return;
            }
          });
        }

        if(this.optionSelectionContainer != null && this.optionSelectionContainer.innerHTML != ''){
          this.optionSelectionContainer.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', this.handleOptionChange.bind(this));
          })
        }
        
        this.updateOptions();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      /**
       * Handles submission of the product form.
       * @param {object} evt - Event object.
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('product-form buy-buttons input[name="id"]').value;
        if (!variantId) {

          document.querySelectorAll('.main-option-container variant-picker .option-selector').forEach((el) => {
            if (el.dataset.selectorType === 'listed') {
              const input = el.querySelector('input');
              // const inputIsValid = input.reportValidity();
              if (!input.checkValidity()) {
                this.submitBtn.textContent = 'Please select a '+el.dataset.option;
                this.submitBtn.classList.add('is-error');
                this.mainProductForm.querySelector('.js-product-form:not(.complementary-product-form) [type="submit"]').textContent = 'Please select a '+el.dataset.option;
                this.mainProductForm.querySelector('.js-product-form:not(.complementary-product-form) [type="submit"]').classList.add('is-error');
              }
            }
          });
          /* stop scroll */
          const target = document.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }

        if(this.submitBtn.dataset.available == 'false'){
          const target = document.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }

        // Validate main form
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductForm.form.checkValidity()) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductForm.form.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Copy data
        this.form.querySelectorAll('[data-copied]').forEach((el) => el.remove());
        const formData = new FormData(this.mainProductForm.form);
        for (const p of formData) {
          if (!this.form.querySelector(`[name="${p[0]}"]`)) {
            const input = document.createElement('input');
            input.name = p[0];
            input.value = p[1];
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.form.append(input);
          }
        }
        super.handleSubmit(evt);
        if(typeof gtag != "undefined"){
          const productTitle = this.querySelector('input[name="id"]').value
          gtag('event', 'Product Page Tracking', {'event_category': 'product page','event_label': 'add to cart sticky','value': productTitle.toLowerCase()});
        }
      }

      /**
       * Determine visibility after scroll.
       */
      static handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky') ? document.querySelector('.section-header').offsetHeight : 0;
        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset
        );
        this.closest('.shopify-section').classList.toggle(
          'sticky-atc--show',
          this.buyButtons.getBoundingClientRect().bottom < topOffset
        );
        
        // document.body.classList.toggle(
        //   'scrolled-to-bottom',
        //   window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        // );
      }

      /**
       * Handle a change in variant on the page.
       * @param {Event} evt - Variant change event dispatched by variant-picker.
       */
      onVariantChange(evt) {
        if(evt.detail.form.classList.contains('complementary-product-form')){
          return;
        }
        const idInput = this.form?.querySelector('[name="id"]');

        if (evt.detail.variant) {
          this.variantTitle.textContent = evt.detail.variant.title;
          this.variantContainer.hidden = false;
          if (idInput) idInput.value = evt.detail.variant.id;
        } else {
          this.variantContainer.hidden = true;
          this.variantTitle.textContent = '';
          if (idInput) idInput.value = '';
        }

        this.updateImage();
        this.updatePrice(evt.detail.variant);
        this.updateOptions(evt.detail);
        this.updateAddToCartButton(evt.detail.variant);
        this.setErrorMsgState();
      }

      /**
       * Update option.
       */
      updateOptions() {
        if(this.optionClone != null && this.optionSelectionContainer.innerHTML != ''){
          // this.optionClone.querySelectorAll(`.option-selector__btns input`).forEach((input) => {
          //   const val = input.value;
          //   this.optionSelectionContainer.querySelector(`input[value="${val}"]`).className = input.className;
          //   this.optionSelectionContainer.querySelector(`input[value="${val}"]`).checked = input.checked == true ? true : false;
          // })
          
          this.optionSelectionContainer.innerHTML = '';
          const options = this.optionClone.querySelector('.option-selector__btns').cloneNode(true);
          options.querySelectorAll('input').forEach((input, index) => {
            input.nextElementSibling.setAttribute('for', `sticky-opt-${input.nextElementSibling.getAttribute('for')}`);
            input.id = `sticky-opt-${input.id}`;
            input.setAttribute('name', `sticky-${input.getAttribute('name')}`);
          });
          this.optionSelectionContainer.appendChild(options);
          options.addEventListener('change', this.handleOptionChange.bind(this));

          // const optionList = this.optionClone.querySelector('.option-selector__btns').querySelectorAll('input[type="radio"]');
          // optionList.forEach((radio) => {
          //   radio.addEventListener('click', function() {
          //     radio.checked = true;
          //   });
          // });

          // const options = this.optionClone.querySelector('.option-selector__btns').innerHTML;
          // this.optionSelectionContainer.innerHTML = `<div class="option-selector__btns flex flex-wrap">${options}</div>`;
        }
      }

      onOptionSelectorClick(evt) {
        this.classList.toggle('open-option-list');
      }

      handleOptionChange(evt) {
        if (document.documentElement.classList.contains('ab-sticky-full')) {
          this.classList.remove('open-option-list');
        }
        const id = evt.target.id;
        const mainId = document.querySelector('.main-option-container').querySelector(`#${id.replace('sticky-opt-', '')}`);
        mainId.checked = true;
        mainId.dispatchEvent(new Event("change", { bubbles: true }));
        // document.querySelector('.main-option-container').dispatchEvent(new Event("change", { bubbles: true }));
        // document.querySelector(`#${id}`).checked = true;

        // console.log(document.querySelector('.main-option-container variant-picker'));
        // document.querySelector('.main-option-container variant-picker').dispatchEvent(new Event("input", { bubbles: true }));
      }

      /**
       * Mirrors the main price and the selected size into the bar (A/B IHR-PDP-6).
       * @param {object} variant - Current variant object.
       */
      updatePrice(variant) {
        if (this.optionValue) {
          const position = Number(this.mobileOptionSelector?.dataset.optionPosition || 0);
          const value = variant && position ? variant.options[position - 1] : '';
          this.optionValue.textContent = value;
          // Long values ("One Size") drop the "Size:" prefix so the product name keeps its room.
          this.optionValue.parentElement.classList.toggle('is-long', value.length > 3);
          this.optionValue.parentElement.classList.toggle('has-value', value !== '');
        }
        if (!this.priceContainer) return;

        // Let the main price block re-render first, then copy it so currency and sale state match.
        setTimeout(() => {
          const prices = Array.from(this.section.querySelectorAll('.product-info__price .price'));
          const mainPrice = prices.find((el) => el.offsetParent) || prices[0];
          const current = mainPrice?.querySelector('.price__default .price__current');
          if (!current) return;
          const onSale = mainPrice.classList.contains('price--on-sale');
          const was = mainPrice.querySelector('.price__default .price__was');
          this.priceContainer.innerHTML = `<span class="sticky-atc__price-current">${current.innerHTML}</span>`
            + (onSale && was && was.textContent.trim() ? `<s class="sticky-atc__price-was">${was.innerHTML}</s>` : '');
          this.priceContainer.classList.toggle('is-sale', onSale);
        });
      }

      /**
       * Updates the image.
       */
      updateImage() {
        const mainImage = this.section.querySelector('.media-gallery .main-image .slider__item.is-active .product-media img');

        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      /**
       * Updates the "Add to Cart" button label and status.
       * @param {object} variant - Current variant object.
       */
      updateAddToCartButton(variant) {
        if (!this.submitBtn) return;

        const variantAvailable = variant && variant.available;
        const unavailableStr = variant
          ? this.submitBtn.dataset.nostockText : this.submitBtn.dataset.unavailableText;

        this.submitBtn.textContent = variantAvailable
          ? this.submitBtn.dataset.addToCartText
          : unavailableStr;

        if(variantAvailable){
          this.submitBtn.disabled = false;
          this.submitBtn.setAttribute('data-available', true);
        }else{
          if(this.submitBtn.dataset.notify == 'false'){
            this.submitBtn.disabled = this.submitBtn.dataset.notify == true ? false : true;
          }
          this.submitBtn.setAttribute('data-available', false);          
        }
        this.submitBtn.classList.remove('is-error');
        // this.submitBtn.disabled = variantAvailable ? false : true;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}
